import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import NavigationBrand from '@segment/templates/NavigationBrand'
import FooterCompact from '@segment/templates/FooterCompact'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import NoBadData from './components/NoBadData'
import Encouragement from './components/Encouragement'

import ogImagePng from './assets/OgImage.png'

const WilcoQuest = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioDark">
      <Layout
        pageTitle="Wilco Quest | Twilio Segment"
        pageDescription="Introducing a partnership between Twilio Segment & Wilco, where you can learn how to use Segment by using it, in a guided, interactive manner!`"
        pageOG={ogImagePng}
        themeColor={theme.palette.twilio.gray[100]}
      >
        <NavigationBrand backgroundColor={theme.palette.twilio.gray[100]} />
        <Hero />
        <Main>
          <NoBadData />
          <Encouragement />
        </Main>
        <FooterCompact />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
`

export default WilcoQuest
